(ns app.front.acceptance.events
  (:require [app.domain.acceptance.model :as acceptance-model]
            [app.domain.review.model :as review-model]
            [app.front.entities :as entities]
            [app.front.process :as process]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::review-id-for-new-acceptance
  (fn [[_ acceptance-parent-id]]
    [(rf/subscribe [::entities/entity acceptance-parent-id])
     (rf/subscribe [:session/user-id])])
  (fn [[acceptance-parent user-id] _]
    (let [reviews (some->> acceptance-parent
                           acceptance-model/reviews-linked-to-acceptance-parent
                           (filter review-model/review-can-get-acceptance?))]
      (:db/id (or (util/only reviews)
                  (->> reviews
                       (filter #(-> % :review/assignee :db/id (= user-id)))
                       util/only))))))

(rf/reg-event-fx ::create
  (fn [_ [_ process-target target-id value text review-id]]
    {:dispatch [::process/signal
                process-target
                [(acceptance-model/value->signal value (some? review-id))
                 (util/mmap target-id text review-id)]
                {:notify      {:success :changes-saved}
                 :track-save? true}]}))

(rf/reg-event-fx ::update-customer-value
  (fn [_ [_ process-target acceptance-id customer-value]]
    {:dispatch [::process/signal
                process-target
                [:process.signal/update-acceptance-customer-value
                 (util/mmap acceptance-id customer-value)]
                {:track-save? true}]}))

(rf/reg-event-fx ::mark-all-changes-done
  (fn [_ [_ process-target form-id acceptance-ids]]
    {:dispatch [::process/signal
                process-target
                [:process.signal/update-acceptance-customer-values-for-form
                 (util/mmap form-id acceptance-ids)]
                {:track-save? true}]}))
